<template>
  <div class="warp">
    <Detail :props-obj="propsObj" />
  </div>
</template>
<script>
import Detail from './detail';
export default {
  name: 'InteractiveTeaAppDetail',
  components: {
    Detail
  },
  data: () => {
    return {
      propsObj: {
        link: 'moduleResult'
      }
    };
  },
  computed: {
  },
  watch: {
    $route: {
      handler: function(route) {
        this.propsObj.propsId = route.params.id;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style scoped lang="scss">
.warp{
  padding:40px 20px 40px 40px;
}
</style>
